import Layout from "../Components/Layout";
import Portfolio from "../Components/Portfolio";

function PortfolioPage() {
    return (
        <Layout>
            <Portfolio />
        </Layout>
    )
}

export default PortfolioPage;